import { Directive } from '@angular/core';

@Directive({
  selector: '[additionalButtons]',
})
export class AdditionalButtonsDirective {}
